export function mergeToLeftRightByIndex<T>(left?: T[], right?: T[]) {
  const l = left ?? [];
  const r = right ?? [];
  const max = Math.max(l.length, r.length);

  return Array.from({ length: max }, (_, i) => ({
    left: l[i],
    right: r[i],
  }));
}

export function mergeToLeftRightByKey<T>(
  left: T[] = [],
  right: T[] = [],
  keySelector: (item: T) => string | number | undefined,
  options?: { sort?: boolean }
) {
  const leftMap = new Map<string | number, T>();
  const rightMap = new Map<string | number, T>();

  for (const item of left) {
    const key = keySelector(item);
    if (key !== undefined) leftMap.set(key, item);
  }

  for (const item of right) {
    const key = keySelector(item);
    if (key !== undefined) rightMap.set(key, item);
  }

  const allKeys = Array.from(new Set([...leftMap.keys(), ...rightMap.keys()]));

  if (options?.sort) {
    allKeys.sort((a, b) => a.toString().localeCompare(b.toString(), undefined, { numeric: true }));
  }

  return allKeys.map((key) => ({
    left: leftMap.get(key),
    right: rightMap.get(key),
  }));
}
